import AuthToken from './AuthToken'
import LocalStorage from './LocalStorage'
import Query from './Query'
import SessionStorage from './SessionStorage'
import User from './User'
import Users from './Users'
import Report from './Report'
import indices from './indices'
import SIIActivitiesService from './getSIIActivities'
import getRegionComuna from './getRegionComuna'
import FileManager from './FileManager'
import DataSources from './DataSources'
import UploadProgress from './UploadProgessService'
import UploadProgressManager from './UploadProgressManager'


export const AuthTokenService = AuthToken
export const LocalStorageService = LocalStorage
export const QueryService = Query
export const SessionStorageService = SessionStorage
export const UserService = User
export const UsersService = Users
export const ReportService = Report
export const indicesService = indices
export const getSIIActivities = SIIActivitiesService
export const getRegionComunaService = getRegionComuna
export const FileManagerService = FileManager
export const DataSourcesService = DataSources
export const UploadProgressService = UploadProgress
export { default as UploadProgressManager } from './UploadProgressManager'
